import script from "./MenuNavegacao.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuNavegacao.vue?vue&type=script&setup=true&lang=js"

import "./MenuNavegacao.vue?vue&type=style&index=0&id=69943ac4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69943ac4"]])

export default __exports__